import { render } from "./IssuesReportModal.vue?vue&type=template&id=8d9417ca"
import script from "./IssuesReportModal.vue?vue&type=script&lang=js"
export * from "./IssuesReportModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__